import { CheckIcon } from "lucide-react";

import { TYPE_CONFIG } from "@/features/tickets/config";
import { TicketType } from "@/features/tickets/types";
import { cn } from "@/shared/lib/utils/cn";

interface Props {
  value: TicketType;
  onChange: (type: TicketType) => void;
  disabled?: boolean;
}

export function TypeSelector({ value, onChange, disabled }: Props) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {(Object.entries(TYPE_CONFIG) as [TicketType, (typeof TYPE_CONFIG)[TicketType]][]).map(([type, cfg]) => {
        const Icon = cfg.icon;
        const selected = value === type;
        return (
          <button
            key={type}
            type="button"
            onClick={() => onChange(type)}
            disabled={disabled}
            className={cn("group flex flex-col items-start gap-2 border p-3 text-left transition-colors", selected ? "border-primary bg-primary/5" : "border-border bg-card hover:border-border hover:bg-accent", disabled && "pointer-events-none opacity-50")}
          >
            <Icon className={cn("size-4 transition-colors", selected ? cfg.className : "text-muted-foreground group-hover:text-foreground")} />
            <div>
              <p className={cn("text-xs font-semibold", selected ? "text-foreground" : "text-muted-foreground")}>{type}</p>
              <p className="mt-0.5 text-[10px] text-muted-foreground leading-tight">{cfg.description}</p>
            </div>
            {selected && <CheckIcon className="ml-auto size-3 text-primary -mt-1 self-end" />}
          </button>
        );
      })}
    </div>
  );
}
